import React from "react";
import { Button, Modal } from "components/haven-design";
import { Channel } from "pages/waitlist-update/types";
import PreviewScroller from "./preview-scroller";
import styles from "./step-review-send.module.css";

interface Props {
  channel: Channel;
  disabled?: boolean;
  requestedInterestIds: string[];
  templateId: string | null;
}

const getChannelData = (channel: Channel) => {
  switch (channel) {
    case Channel.EMAIL:
      return {
        channelName: "Email",
        previewButtonText: "Preview Emails",
      };

    case Channel.LETTER:
      return {
        channelName: "Physical Letter",
        previewButtonText: "Preview Letters",
      };

    case Channel.SMS:
      return {
        channelName: "Text Message",
        previewButtonText: "Preview Texts",
      };
    default:
      return {};
  }
};

export const PreviewVariablesButton: React.FC<Props> = props => {
  const [isModalOpen, setModalOpen] = React.useState(false);
  const { channelName, previewButtonText } = getChannelData(props.channel);
  return (
    <div className={styles.container}>
      <Button
        size="S"
        color="secondary"
        className="margin-bottom-s"
        disabled={props.disabled}
        onClick={() => setModalOpen(true)}
      >
        {previewButtonText}
      </Button>

      {props.templateId && (
        <Modal
          title={`${channelName} Preview`}
          isOpen={isModalOpen}
          onRequestClose={() => setModalOpen(false)}
        >
          <div className="color-secondary margin-bottom-l">
            This is a preview of the messages that will be delivered to applicants who will be
            removed from the waitlist after submitting this form.
          </div>
          <PreviewScroller
            requestedInterestIds={props.requestedInterestIds}
            templateId={props.templateId}
          />
        </Modal>
      )}
    </div>
  );
};
